import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import httpClient from '../../../http/HttpRequest';
import Alert from '../../../feature/Alert';
import { PRODUCT_LIST, UNIT_LIST, COMPANY_DETAILS } from '../../../data/url';
import Select from 'react-select';
import Helper from '../../../helper/Helper';
import NewPayment from '../payment/NewPayment';
import AddProduct from '../product/AddProduct';
import UnitModal from '../../modals/UnitModal';

const ProductCal = (props) => {
  const { t } = useTranslation();

  const { title, onSubmit, customer, products, notes, payment } = props;

  const [productData, setProductData] = useState({});

  const [unitModalStatus, setUnitModal] = useState(false);

  const [productOption, setProductOption] = useState({});

  const [unitList, setUnitList] = useState({});

  const [companyData, setcompanyData] = useState({});

  const [sameState, setSameState] = useState(0);

  const [errors, setErrors] = useState({});

  const emptyRow = { selectedProduct: null, desc: '', sac: '', selectedUnit: null, quantity: '', price: '', discount: '', discountType: 1, tax: '', total: '', stock: '', taxableAmount: '', discountAmount: '', taxAmount: '' };

  const [defualtRow, setDefualtRow] = useState(emptyRow);

  const [commanData, setCommanData] = useState({ terms_conditions: '', private_notes: '' });

  const [rows, setRows] = useState([]);

  const [totals, setTotal] = useState({ totalFinal: 0, totalTaxable: 0, totalDiscount: 0, totalTaxAmount: 0, totalPriceAmount: 0, allDiscount: 0, paidAmount: 0, pendingAmount: 0, excessAmount: 0 });

  const [editIndex, setEditIndex] = useState(-1);

  const [addDiscountAll, setAddDiscountAll] = useState(false);

  const [allDiscountType, setAllDiscountType] = useState(1);

  const [paymentDetails, setPaymentDetails] = useState({});

  const btnStyle = { padding: "5px", borderRadius: "10px", margin: "2px" };

  const thStyle = { lineHeight: "1", verticalAlign: "center" };

  const [paymentDiv, setPaymentDiv] = useState(false);

  const [productModal, setProductModal] = useState(false);

  useEffect(() => {
    if (products && products.length > 0) {
      setRows(products);
    }
  }, [products]);

  useEffect(() => {
    if (notes) {
      setCommanData({ terms_conditions: notes.terms_conditions, private_notes: notes.private_notes });
    }
  }, [notes]);

  const validateField = () => {
    let formErrors = {};
    let valid = true;
    if (defualtRow.selectedProduct === null) {
      formErrors.selectedProduct = 'field_required';
      valid = false;
    }
    if (defualtRow.price === '') {
      formErrors.price = 'field_required';
      valid = false;
    }
    if (isNaN(Number(defualtRow.price))) {
      formErrors.price = 'field_numeric';
      valid = false;
    }
    if (defualtRow.quantity === '') {
      formErrors.quantity = 'field_required';
      valid = false;
    }
    if (isNaN(Number(defualtRow.quantity))) {
      formErrors.quantity = 'field_numeric';
      valid = false;
    }
    setErrors(formErrors);
    return valid;
  }

  const handleAddRow = () => {
    if (validateField()) {
      setRows([...rows, defualtRow]);
      setDefualtRow(emptyRow);
      calculations();
    }

  };

  const handleEditRow = (index) => {
    setEditIndex(index);
    const editedRow = rows[index];
    let pricing = calculatePrice(editedRow.price, editedRow.qty, editedRow.gst_rate, editedRow.discount, editedRow.discountType);
    if (pricing) {
      editedRow.total = pricing.total;
      editedRow.taxableAmount = pricing.taxableAmount;
      editedRow.discountAmount = pricing.discountAmount;
      editedRow.taxAmount = pricing.taxAmount;
    }
    setDefualtRow(editedRow);
  };

  const handleUpdateRow = () => {
    const updatedRows = [...rows];
    updatedRows[editIndex] = { ...defualtRow };
    setRows(updatedRows);
    setEditIndex(-1);
    setDefualtRow(emptyRow);
    calculations();
  }

  const handleCancel = () => {
    setEditIndex(-1);
    setErrors({});
    setDefualtRow(emptyRow);
  }

  const handleRemoveRow = (indexToRemove) => {
    const updatedRows = rows.filter((_, index) => index !== indexToRemove);
    setRows(updatedRows);
    calculations();
  };

  const handleInputChange = (fieldName, event) => {
    const value = event.target.value;
    const updatedRow = { ...defualtRow };
    updatedRow[fieldName] = value;
    setDefualtRow(updatedRow);
    if (fieldName === 'price' || fieldName === 'quantity' || fieldName === 'discount' || fieldName === 'tax' || fieldName === 'discountType') {
      onPriceChange(updatedRow);
    }
  };

  const handleCommanData = (fieldName, event) => {
    const value = event.target.value;
    const updatedRow = { ...commanData };
    updatedRow[fieldName] = value;
    setCommanData(updatedRow);
  };

  useEffect(() => {
    calculations();
  }, [rows]);

  useEffect(() => {
    if (customer.state === companyData.state) {
      setSameState(1);
    } else {
      setSameState(0);
    }
  }, [customer]);

  useEffect(() => {
    getUnit();
    getProductData();
    getCompanyDetails();
  }, []);

  const getUnit = async (e) => {
    const res = await httpClient.post(UNIT_LIST, {});
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        let options = [];
        result.data.forEach((row, index) => {
          options.push({ label: row.name, value: row.id });
        });
        setUnitList(options);
      }
    }
  }

  const getProductData = async () => {
    const res = await httpClient.post(PRODUCT_LIST, {});
    if (res.requestStatus === 'OK') {
      const result = res.result;
      if (result.status === 1) {
        setProductData(result.data);
        let options = [];
        result.data.forEach((row, index) => {
          options.push({ label: row.product_name, value: row.product_id });
        });
        setProductOption(options);
      } else {
        Alert.error(res.message);
      }
    }
  };

  const onProductChange = (selectedOption) => {
    const qty = 1;
    const updatedRows = { ...defualtRow };
    updatedRows.selectedProduct = selectedOption;
    let p_id = selectedOption.value;
    const productDetails = findProduct(p_id);
    updatedRows.sac = productDetails.sac_code;
    updatedRows.price = productDetails.price;
    updatedRows.stock = productDetails.stock_quantity;
    updatedRows.tax = productDetails.gst_rate;
    updatedRows.quantity = qty;
    updatedRows.discount = addDiscountAll === true ? totals.allDiscount : productDetails.discount;
    updatedRows.discountType = addDiscountAll === true ? allDiscountType : defualtRow.discountType;
    const unit = unitList.find(element => element.value === productDetails.unit);
    updatedRows.selectedUnit = unit;
    let pricing = calculatePrice(productDetails.price, qty, productDetails.gst_rate, updatedRows.discount, updatedRows.discountType);
    if (pricing) {
      updatedRows.total = pricing.total;
      updatedRows.taxableAmount = pricing.taxableAmount;
      updatedRows.discountAmount = pricing.discountAmount;
      updatedRows.taxAmount = pricing.taxAmount;
    }
    setDefualtRow(updatedRows);

  };

  const onPriceChange = (updatedRows) => {
    let pricing = calculatePrice(updatedRows.price, updatedRows.quantity, updatedRows.tax, updatedRows.discount, updatedRows.discountType);
    if (pricing) {
      updatedRows.total = pricing.total;
      updatedRows.taxableAmount = pricing.taxableAmount;
      updatedRows.discountAmount = pricing.discountAmount;
      updatedRows.taxAmount = pricing.taxAmount;
    }
    setDefualtRow(updatedRows);
  }

  const calculatePrice = (p, quantity, Tax, Discount, DiscountType, allDiscount = 0) => {
    let price = Helper.convertToDecimal(p);
    if (price) {
      let qty = Helper.convertToDecimal(quantity);
      if (qty) {
        let tax = Helper.convertToDecimal(Tax);
        if (tax !== undefined) {
          let total = price * qty;
          let disc = allDiscount > 0 ? allDiscount : Helper.convertToDecimal(Discount);
          let discountAmount = 0;
          if (disc) {
            if (disc > 0) {
              if (DiscountType == 1) {
                discountAmount = total * (disc / 100);
              } else if (DiscountType == 2) {
                discountAmount = disc;
              }
            }
          }
          total = total - discountAmount;
          let taxAmount = (total * (tax / 100));
          let final = taxAmount + total;
          return {
            total: Helper.formatNumber(final),
            taxableAmount: Helper.formatNumber(total),
            discountAmount: Helper.formatNumber(discountAmount),
            taxAmount: Helper.formatNumber(taxAmount)
          }
        }
      }
    }
  }

  const calculations = () => {
    let sumTaxableAmount = 0;
    let sumDiscountAmount = 0;
    let sumTotalAmount = 0;
    let sumTotalTaxAmount = 0;
    let sumTotalPrice = 0;
    rows.forEach((row) => {
      sumTaxableAmount += parseFloat(row.taxableAmount);
      sumDiscountAmount += parseFloat(row.discountAmount);
      sumTotalAmount += parseFloat(row.total);
      sumTotalTaxAmount += parseFloat(row.taxAmount);
      sumTotalPrice += parseFloat(row.price);
    });
    setTotal(prevTotal => ({
      ...prevTotal,
      totalFinal: Helper.formatNumber(sumTotalAmount),
      totalTaxable: Helper.formatNumber(sumTaxableAmount),
      totalDiscount: Helper.formatNumber(sumDiscountAmount),
      totalTaxAmount: Helper.formatNumber(sumTotalTaxAmount),
      totalPriceAmount: Helper.formatNumber(sumTotalPrice),
      pendingAmount: Helper.formatNumber(sumTotalAmount)
    }));
  }

  const findProduct = (product_id) => {
    const productDetails = productData.find(element => element.product_id === product_id);
    return productDetails;
  };

  const onUnitChange = (selectedOption) => {
    const updatedRows = { ...defualtRow };
    updatedRows.selectedUnit = selectedOption;
    setDefualtRow(updatedRows);
  };

  const saveOrder = () => {
    let t = totals;
    let taxType = sameState;
    t['discount_type'] = allDiscountType;
    onSubmit(rows, commanData, t, taxType, paymentDetails);
  }

  const handleAllDiscountCheckbox = (event) => {
    setAddDiscountAll(event.target.checked);
    setTotal(prevTotal => ({
      ...prevTotal,
      allDiscount: 0
    }));
    setAllDiscountType(1);
    applyAllDiscount();
  };

  const applyAllDiscount = () => {
    const allDiscount = totals.allDiscount;
    if (allDiscount > 0) {
      const updatedRows = rows.map(row => {
        let pricing = calculatePrice(row.price, row.quantity, row.tax, row.discount, allDiscountType, allDiscount);
        if (pricing) {
          return {
            ...row,
            discount: allDiscount,
            discountType: allDiscountType,
            total: pricing.total,
            discountAmount: pricing.discountAmount,
            taxableAmount: pricing.taxableAmount,
            taxAmount: pricing.taxAmount
          };
        }
      });
      setRows(updatedRows);
      calculations();
    }
  }
  const handleAllDiscount = (event) => {
    const discount = event.target.value;
    setTotal(prevTotal => ({
      ...prevTotal,
      allDiscount: discount
    }));
    applyAllDiscount();
  }

  const handleAllDiscountTypeChange = (event) => {
    const t = event.target.value;
    setAllDiscountType(t);
    applyAllDiscount();
  }

  useEffect(() => {
    applyAllDiscount();
  }, [totals.allDiscount, allDiscountType, addDiscountAll]);

  const getCompanyDetails = async () => {
    const res = await httpClient.post(COMPANY_DETAILS, {});
    if (res.requestStatus === 'OK') {
      const result = res.result;
      if (result.status === 1) {
        setcompanyData(result.data);
      } else {
        Alert.error(res.message);
      }
    }
  };

  const addPayment = (paymentDetails) => {
    setPaymentDetails(paymentDetails);
    let pending = 0;
    let excess = 0;
    if (parseFloat(totals.totalFinal) > parseFloat(paymentDetails.amount)) {
      pending = parseFloat(totals.totalFinal) - parseFloat(paymentDetails.amount);
    }
    if (parseFloat(totals.totalFinal) < parseFloat(paymentDetails.amount)) {
      excess = parseFloat(paymentDetails.amount) - parseFloat(totals.totalFinal);
    }
    setTotal(prevTotal => ({
      ...prevTotal,
      paidAmount: Helper.formatNumber(paymentDetails.amount),
      pendingAmount: Helper.formatNumber(pending),
      excessAmount: Helper.formatNumber(excess),
    }));

  }

  const handlePyamentDiv = () => {
    setPaymentDiv(!paymentDiv);
  }

  const openModal = (modalName) => {
    if (modalName === 'product') {
      setProductModal(true);
    }
  };

  const closeModal = (modalName, data = {}) => {
    if (modalName === 'product') {
      setProductModal(false);
      if (Object.keys(data).length > 0) {
        if (data.status === 'RESULT_OK') {
          getProductData();
        }
      }
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === 's') {
        event.preventDefault();
        saveOrder();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const closeUnitModal = (modalName, data = {}) => {
    if (modalName === 'unitModal') {
      setUnitModal(false);
      if (Object.keys(data).length > 0) {
        if (data.status === 'RESULT_OK') {
          getUnit();
        }
      }
    }
  };

  return (
    <div className='continer-fluid'>
      <hr />
      <h5 className='text-center mt-2'>{t(title)}</h5>

      <div className='p-2 mt-2 bg-light d-flex flex-wrap'>
        <div style={{ width: "20%", minWidth: "200px", maxWidth: "300px", margin: "0 1px" }}>
          <label className='small'>{t('product')} </label> <button className='btn btn-sm btn-outline-primary btn-fw' onClick={(e) => openModal('product')}>+</button>
          <Select
            value={defualtRow.selectedProduct}
            options={productOption}
            isSearchable={true}
            placeholder="Select"
            id='product_id'
            onChange={(selectedOption) => onProductChange(selectedOption)}
          />
          {errors.selectedProduct && <p style={{ color: "red" }}>{t(errors.selectedProduct)}</p>}
          <textarea
            className='form-control form-control-sm mt-1'
            placeholder={t('desc')}
            id='desc'
            onChange={(e) => handleInputChange('desc', e)}
            value={defualtRow.desc}></textarea>
        </div>
        <div style={{ width: "9%", minWidth: "90px", margin: "0 1px", maxWidth: "100px", }}>
          <label className='small'>{t('unit')}</label> <button className='btn btn-sm btn-outline-primary btn-fw' onClick={(e) => setUnitModal(true)}>+</button>
          <Select
            id='unit'
            value={defualtRow.selectedUnit}
            options={unitList}
            isSearchable={true}
            placeholder="Select"
            onChange={(selectedOption) => onUnitChange(selectedOption)}
          />
        </div>
        <div className='text-center' style={{ width: "7%", minWidth: "60px", margin: "0 1px", maxWidth: "80px" }}>
          <label className='small' htmlFor='quantity'>{t('qty')}</label>
          <input
            id='quantity'
            type='number'
            className='form-control form-control-sm'
            value={defualtRow.quantity}
            onChange={(e) => handleInputChange('quantity', e)}
          />
          {errors.quantity && <p style={{ color: "red" }}>{t(errors.quantity)}</p>}
        </div>
        <div className='text-center' style={{ width: "8%", minWidth: "90px", margin: "0 1px", maxWidth: "100px" }}>
          <label className='small' htmlFor='price'>{t('price')}</label>
          <input
            id='price'
            type='number'
            className='form-control form-control-sm'
            value={defualtRow.price}
            onChange={(e) => handleInputChange('price', e)}
          />
          {errors.price && <p style={{ color: "red" }}>{t(errors.price)}</p>}
        </div>

        <div className='text-center' style={{ width: "7%", minWidth: "60px", margin: "0 1px", maxWidth: "90px" }}>
          <label className='small' htmlFor='discount'>{t('discount')}</label>
          <input
            id='discount'
            type='number'
            className='form-control form-control-sm'
            value={defualtRow.discount}
            onChange={(e) => handleInputChange('discount', e)}
          />
          <p className='text-success mt-1'>{defualtRow.discountAmount > 0 ? defualtRow.discountAmount : ''}</p>
        </div>
        <div className='text-center' style={{ width: "7%", minWidth: "70px", margin: "0 1px", maxWidth: "90px" }}>
          <label className='small' htmlFor='discountType'>{t('type')}</label>
          <select id='discountType' className='form-control form-control-sm' value={defualtRow.discountType} onChange={(e) => handleInputChange('discountType', e)}>
            <option value={1}>%</option>
            <option value={2}>Fixed</option>
          </select>
        </div>
        <div className='text-center' style={{ width: "7%", minWidth: "70px", margin: "0 1px", maxWidth: "90px" }}>
          <label className='small' htmlFor='tax'>{t('tax')}</label>
          <input
            id='tax'
            type='number'
            className='form-control form-control-sm'
            value={defualtRow.tax}
            onChange={(e) => handleInputChange('tax', e)}
          />
        </div>
        <div className='text-center' style={{ width: "8%", minWidth: "80px", margin: "0 1px", maxWidth: "100px" }}>
          <label className='small' htmlFor='sac'>{t('sac')}</label>
          <input
            id='sac'
            type='text'
            value={defualtRow.sac}
            className='form-control form-control-sm'
            onChange={(e) => handleInputChange('sac', e)}
          />
        </div>
        <div className='text-center' style={{ width: "12%", minWidth: "110px", margin: "0 1px", maxWidth: "140px" }}>
          <label className='small' htmlFor='taxable_amount'>{t('tax_amt')}</label>
          <input
            id='taxable_amount'
            type='text'
            className='form-control form-control-sm'
            disabled
            value={defualtRow.taxableAmount}
          />
          {
            editIndex === -1 ? (

              <button onClick={() => handleAddRow()} className='btn btn-primary mt-2 auto_click'>
                {t('add')}
              </button>
            ) : (
              <button onClick={() => handleUpdateRow()} className='btn btn-primary mt-2'>
                {t('update')}
              </button>
            )
          }
        </div>
        <div className='text-center' style={{ width: "12%", minWidth: "110px", margin: "0 1px", maxWidth: "140px" }}>
          <label className='small' htmlFor='total'>{t('total')}</label>
          <input
            id='total'
            type='text'
            className='form-control form-control-sm'
            disabled
            value={defualtRow.total}
          />
          <button onClick={() => handleCancel()} className='btn btn-danger mt-2'>
            {t('cancel')}
          </button>
        </div>
      </div>

      <div className='mt-2'>
        <div className='table-responsive'>
          <table className='table table-striped table-sm table-bordered table-hovered'>
            <thead>
              <tr className='text-center' >
                <th style={thStyle} >#</th>
                <th style={thStyle}>{t('product')}</th>
                <th style={thStyle}>{t('unit')}</th>
                <th style={thStyle}>{t('qty')}</th>
                <th style={thStyle}>{t('price')}</th>
                <th style={thStyle}>{t('discount')}</th>
                <th style={thStyle}>{t('taxable')}</th>
                {
                  sameState === 1 ? (
                    <>
                      <th style={thStyle}>{t('cgst')}</th>
                      <th style={thStyle}>{t('sgst')}</th>
                    </>
                  ) : (
                    <th style={thStyle}>{t('igst')}</th>
                  )
                }
                <th style={thStyle}>{t('total')}</th>
                <th style={thStyle}>{t('action')}</th>
              </tr>
            </thead>
            <tbody className='pt-2'>
              {
                rows.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td style={{ width: "200px" }}>{row.selectedProduct.label} <br /><small>{row.desc}</small></td>
                    <td>{row.selectedUnit !== undefined ? row.selectedUnit.label : ''}</td>
                    <td className='text-right'><small>{row.quantity}</small></td>
                    <td className='text-right'><small>{row.price}</small></td>
                    <td className='text-right'><small>{row.discountAmount} <br />{row.discountType == 1 ? `${row.discount} %` : ''}</small></td>
                    <td className='text-right'><small>{row.taxableAmount}</small></td>
                    {
                      sameState === 1 ? (
                        <>
                          <td className='text-right'><small>{(row.taxAmount / 2).toFixed(2)} <br />{(row.tax / 2).toFixed(2)} % </small></td>
                          <td className='text-right'><small>{(row.taxAmount / 2).toFixed(2)} <br />{(row.tax / 2).toFixed(2)} % </small></td>
                        </>
                      ) : (
                        <td className='text-right'><small>{row.taxAmount} <br />{row.tax} % </small></td>
                      )
                    }

                    <td className='text-right'><small>{row.total}</small></td>
                    <td className='text-center'>
                      <button onClick={() => handleEditRow(index)} className='btn btn-sm btn-primary' style={btnStyle}>
                        <i className='mdi mdi-lead-pencil'></i>
                      </button>
                      <button onClick={() => handleRemoveRow(index)} className='btn btn-sm btn-danger' style={btnStyle}>
                        <i className='mdi mdi-minus-box'></i>
                      </button>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
      <hr />
      <div className='row mt-3'>
        <div className='col-md-8'>
          <div className='row'>
            <div className='col-md-6'>
              <div className="form-check form-check-primary">
                <label className="form-check-label">
                  <input id="add_discount_all" type="checkbox" className="form-check-input" checked={addDiscountAll} onChange={handleAllDiscountCheckbox} />
                  {t('add_discount_to_all')}
                  <i className="input-helper"></i></label>
              </div>
            </div>
            <div className='col-md-4'>
              {addDiscountAll && <input type='number' className='form-control form-control-sm' value={totals.allDiscount} onChange={handleAllDiscount} />}
            </div>
            <div className='col-md-2'>
              {addDiscountAll &&
                <select className='form-control form-control-sm' value={allDiscountType} onChange={handleAllDiscountTypeChange}>
                  <option value={1}>%</option>
                  <option value={2}>Fixed</option>
                </select>
              }
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <label className='small' htmlFor='terms_conditions'>{t('terms_conditions')}</label>
              <textarea className='form-control form-control-sm' id='terms_conditions' value={commanData.terms_conditions} onChange={(e) => handleCommanData('terms_conditions', e)}></textarea>
            </div>
            <div className='col-md-6'>
              <label className='small' htmlFor='private_notes'>{t('private_notes')}</label>
              <textarea className='form-control form-control-sm' id='private_notes' value={commanData.private_notes} onChange={(e) => handleCommanData('private_notes', e)}></textarea>
            </div>
          </div>
        </div>
        <div className='col-md-4 '>
          <table className='table table-sm table-borderless'>
            <tbody>
              <tr>
                <td style={thStyle}><strong>{t('total_amount')}</strong></td>
                <td style={thStyle} className='text-right'><strong>{totals.totalPriceAmount}</strong></td>
              </tr>
              <tr>
                <td style={thStyle}><strong>{t('total_discount')}</strong></td>
                <td style={thStyle} className='text-right'><strong>{totals.totalDiscount}</strong></td>
              </tr>
              <tr>
                <td style={thStyle}><strong>{t('total_taxable')}</strong></td>
                <td style={thStyle} className='text-right'><strong>{totals.totalTaxable}</strong></td>
              </tr>
              <tr>
                <td style={thStyle}><strong>{t('total_tax')}</strong></td>
                <td style={thStyle} className='text-right'><strong>{totals.totalTaxAmount}</strong></td>
              </tr>
              <tr>
                <td style={thStyle} className='text-success'><strong>{t('net_amount')}</strong></td>
                <td style={thStyle} className='text-right text-success'><strong>{totals.totalFinal}</strong></td>
              </tr>
              {
                title === 'invoice_details' && totals.paidAmount > 0 &&
                <tr>
                  <td style={thStyle} className='text-success'><strong>{t('paid_amount')}</strong></td>
                  <td style={thStyle} className='text-right text-success'><strong>{totals.paidAmount}</strong></td>
                </tr>
              }
              {
                title === 'invoice_details' && totals.pendingAmount > 0 &&
                <tr>
                  <td style={thStyle} className='text-danger'><strong>{t('pending_amount')}</strong></td>
                  <td style={thStyle} className='text-right text-danger'><strong>{totals.pendingAmount}</strong></td>
                </tr>
              }
              {
                title === 'invoice_details' && totals.excessAmount > 0 &&
                <tr>
                  <td style={thStyle} className='text-infor'><strong>{t('excess_amount')}</strong></td>
                  <td style={thStyle} className='text-right text-success'><strong>{totals.excessAmount}</strong></td>
                </tr>
              }

            </tbody>
          </table>
        </div>
      </div>
      {payment && (
        <>
          <div>
            <div className="form-check form-check-primary">
              <label className="form-check-label">
                <input type="checkbox" className="form-check-input" checked={paymentDiv} onChange={handlePyamentDiv} />
                {t('add_payment')}
                <i className="input-helper"></i></label>
            </div>
          </div>
          {
            paymentDiv && <NewPayment onClick={addPayment} />
          }
        </>
      )
      }
      <hr />
      <div className='text-center mt-2'>
        <button className='btn btn-primary auto_click' onClick={saveOrder}>{t('save')}</button>
      </div>
      <AddProduct show={productModal} handleClose={closeModal} />
      <UnitModal show={unitModalStatus} handleClose={closeUnitModal} />
    </div>
  );
};

export default ProductCal;
